import React from "react"
import PropTypes from "prop-types"
import { A } from "AtomicComponents"
import { withRadium } from "higher-order-components"

const GlobalNavLinkSecondary = ({
  name, href, gtm
}) => (
  <A
    data-test="secondary-link"
    href={href}
    withoutStyle
    gtm={gtm}>
    <span style={styles.base}>
      {name}
    </span>
  </A>
)

const styles = {
  base: {
    textDecoration: "none",
    padding: ".75em 0",
    display: "block",
    color: "#808080",
    "@media (min-width: 1700px)": {
      fontSize: "125%"
    },
    ":hover": {
      color: "#101010",
      transition: ".2s ease-in-out"
    }
  }
}

GlobalNavLinkSecondary.propTypes = {
  name: PropTypes.string,
  href: PropTypes.string
}

GlobalNavLinkSecondary.defaultProps = {
  name: "",
  href: ""
}

export default withRadium()(GlobalNavLinkSecondary)



// WEBPACK FOOTER //
// ./src/components/global-nav-link-secondary/index.jsx